import { render, staticRenderFns } from "./VendorCreateForm.vue?vue&type=template&id=2cbcd0fe&"
import script from "./VendorCreateForm.vue?vue&type=script&lang=js&"
export * from "./VendorCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports